import { Component, OnInit } from '@angular/core';
import { MenuService } from 'src/app/services/menu.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-menu-access',
  templateUrl: './user-menu-access.component.html',
  styleUrls: ['./user-menu-access.component.css'],
})
export class UserMenuAccessComponent implements OnInit {
  empName: any;
  filterEmpName: string;
  menus: any[] = [];
  expandedMenuIds = new Set<number>();
  successFlag = false;
  message: string;

  constructor(
    private menuService: MenuService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    // No menu loaded until an employee is selected.
  }

  empNameSelected(emp: any) {
    this.empName = emp;
    if (this.empName) {
      this.getEmployeeMenu();
    }
  }

  getEmployeeMenu() {
    let empId = this.empName.split('-')[0].trim();
    console.log('Selected Employee ID: ' + empId);
    this.menuService.getEmpMenu(empId).subscribe((res: any) => {
      this.menus = this.sortMenuList(res || []);
    });
  }

  private sortMenuList(menuList: any[]): any[] {
    return menuList
      .slice()
      .sort((a, b) => (a.menuOrder ?? 0) - (b.menuOrder ?? 0))
      .map((menu) => ({
        ...menu,
        children: Array.isArray(menu.children)
          ? menu.children
              .slice()
              .sort((a, b) => (a.menuOrder ?? 0) - (b.menuOrder ?? 0))
          : [],
      }));
  }

  onParentCheckboxChange(menu: any, checked: boolean): void {
    menu.checked = checked;
    if (menu.children?.length) {
      menu.children.forEach((child: any) => (child.checked = checked));
    }
  }

  onChildCheckboxChange(menu: any, child: any, checked: boolean): void {
    child.checked = checked;
    if (menu.children?.length) {
      menu.checked = menu.children.some((c: any) => c.checked);
    }
  }

  isExpanded(menu: any): boolean {
    return this.expandedMenuIds.has(menu.id);
  }

  toggleMenu(menu: any): void {
    if (!menu.children?.length) {
      return;
    }

    if (this.expandedMenuIds.has(menu.id)) {
      this.expandedMenuIds.delete(menu.id);
    } else {
      this.expandedMenuIds.add(menu.id);
    }
  }

  grantMenuAccess(): void {
    if (!this.empName || !this.menus.length) {
      alert('Please select an employee and configure menus.');
      return;
    }

    const checkedMenuIds = this.collectCheckedMenuIds();
    const empId = this.empName.split('-')[0].trim();

    const payload = {
      employeeId: empId,
      checkedMenuIds: checkedMenuIds,
    };

    console.log('Granting menu access:', payload);

    this.menuService.grantMenuAccess(payload).subscribe(
      (response: any) => {
        this.successFlag = true;
        this.message = 'Menu access granted successfully!';
        setTimeout(() => {
          this.successFlag = false;
        }, 5000);
      },
      (error: any) => {
        this.successFlag = true;
        this.message = 'Error granting menu access. Please try again.';
        setTimeout(() => {
          this.successFlag = false;
        }, 5000);
        console.error('Error:', error);
      },
    );
  }

  private collectCheckedMenuIds(): number[] {
    const checkedIds: number[] = [];

    this.menus.forEach((menu: any) => {
      if (menu.checked) {
        checkedIds.push(menu.id);
      }
      if (menu.children?.length) {
        menu.children.forEach((child: any) => {
          if (child.checked) {
            checkedIds.push(child.id);
          }
        });
      }
    });

    return checkedIds;
  }
}
